import { persistQueryParamsToStorage } from './util/param-util';

persistQueryParamsToStorage();
